import { useState } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { VStack, Box, Field, Input, NativeSelect, Text, HStack, IconButton } from '@chakra-ui/react'
import { FaCircleQuestion } from 'react-icons/fa6'
import { SecurityCodePopupModal } from '@!/components/CreditCard/components'

export const CreditCardForm = ({ onSubmit, fontSize = 'md', children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const onOpen = () => setIsOpen(true)
  const onClose = () => setIsOpen(false)
  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      cardNumber: '',
      cardName: '',
      expireMonth: '',
      expireYear: '',
      securityCode: '',
    },
  })

  const getMonthList = () => {
    return Array.from({ length: 12 }, (_, i) => {
      const month = (i + 1).toString().padStart(2, '0')
      return { value: month, name: `${month}月` }
    })
  }

  const getYearList = () => {
    const currentYear = new Date().getFullYear()
    return Array.from({ length: 10 }, (_, i) => currentYear + i)
  }

  const onSubmitForm = (data) => {
    onSubmit(data, setError)
  }

  return (
    <Box w="100%">
      <form onSubmit={handleSubmit(onSubmitForm)}>
        <VStack>
          <Text fontSize="sm" color="red.500" w="100%">
            {errors.root?.message}
          </Text>
          <Controller
            name="cardNumber"
            control={control}
            rules={{
              required: 'カード番号を入力してください。',
              pattern: {
                value: /^\d{14,16}$/,
                message: 'カード番号は14桁から16桁の数字で入力してください。',
              },
            }}
            render={({ field }) => (
              <Field.Root invalid={!!errors.cardNumber} required mb="2">
                <Field.Label fontSize={fontSize}>クレジットカード番号</Field.Label>
                <Input {...field} type="tel" placeholder="0123456789012345" maxLength={16} fontSize={fontSize} bgColor="bg.secondary" />
                <Text fontSize="sm" color="red.500">
                  {errors.cardNumber?.message}
                </Text>
              </Field.Root>
            )}
          />

          <Controller
            name="cardName"
            control={control}
            rules={{ required: 'カード名義を入力してください。', pattern: { value: /^[A-Z\s]+$/, message: '半角大文字のアルファベットで入力してください。' } }}
            render={({ field }) => (
              <Field.Root invalid={!!errors.cardName} required mb="2">
                <Field.Label fontSize={fontSize}>カード名義</Field.Label>
                <Input {...field} placeholder="TARO MANGA" fontSize={fontSize} bgColor="bg.secondary" />
                <Text fontSize="sm" color="red.500">
                  {errors.cardName?.message}
                </Text>
              </Field.Root>
            )}
          />

          <Field.Root invalid={!!(errors.expireMonth || errors.expireYear)} required mb="2">
            <Field.Label fontSize={fontSize}>有効期限</Field.Label>
            <HStack w="60%">
              <Controller
                name="expireMonth"
                control={control}
                rules={{ required: '有効期限(月)を選択してください。' }}
                render={({ field }) => (
                  <NativeSelect.Root>
                    <NativeSelect.Field {...field} placeholder="月" fontSize={fontSize} bgColor="bg.secondary">
                      {getMonthList().map((month) => (
                        <option key={month.value} value={month.value}>
                          {month.name}
                        </option>
                      ))}
                    </NativeSelect.Field>
                    <NativeSelect.Indicator />
                  </NativeSelect.Root>
                )}
              />
              <Controller
                name="expireYear"
                control={control}
                rules={{ required: '有効期限(年)を選択してください。' }}
                render={({ field }) => (
                  <NativeSelect.Root>
                    <NativeSelect.Field {...field} placeholder="年" fontSize={fontSize} bgColor="bg.secondary">
                      {getYearList().map((year) => (
                        <option key={year} value={year}>
                          {year}
                        </option>
                      ))}
                    </NativeSelect.Field>
                    <NativeSelect.Indicator />
                  </NativeSelect.Root>
                )}
              />
            </HStack>
            <Text fontSize="sm" color="red.500">
              {errors.expireMonth?.message || errors.expireYear?.message}
            </Text>
          </Field.Root>

          <Controller
            name="securityCode"
            control={control}
            rules={{
              required: 'セキュリティコードを入力してください。',
              pattern: { value: /^\d{3,4}$/, message: 'セキュリティコードは3桁または4桁の数字で入力してください。' },
            }}
            render={({ field }) => (
              <Field.Root invalid={!!errors.securityCode} required mb="2">
                <Field.Label fontSize={fontSize}>セキュリティコード</Field.Label>
                <HStack w="60%">
                  <Input {...field} type="tel" maxLength={4} fontSize={fontSize} bgColor="bg.secondary" />
                  <IconButton variant="ghost" size="xs" aria-label="セキュリティコードについて" color="label.tertiary" onClick={onOpen}>
                    <FaCircleQuestion />
                  </IconButton>
                </HStack>
                <Text fontSize="sm" color="red.500">
                  {errors.securityCode?.message}
                </Text>
              </Field.Root>
            )}
          />

          {/* ボタン */}
          {children}
        </VStack>
      </form>
      <SecurityCodePopupModal isOpen={isOpen} onClose={onClose} />
    </Box>
  )
}

export default CreditCardForm
